import { Component, DestroyRef, OnInit, inject, output, input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store } from '@ngxs/store';
import { NzModalService, NzModalModule } from 'ng-zorro-antd/modal';
import { JobAlertActions } from 'src/app/store/job-alert/job-alert.actions';
import { JobAlertState } from 'src/app/store/job-alert/job-alert.state';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { RouterLink } from '@angular/router';
import { JobAlertFormComponent } from './job-alert-form/job-alert-form.component';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzButtonModule } from 'ng-zorro-antd/button';

@Component({
    selector: 'app-job-alert',
    templateUrl: './job-alert.component.html',
    styleUrls: ['./job-alert.component.scss'],
    imports: [NzModalModule, NzGridModule, RouterLink, JobAlertFormComponent, NzDividerModule, NzSpaceModule, NzButtonModule]
})
export class JobAlertComponent implements OnInit {
	private store = inject(Store);
	private nzModalService = inject(NzModalService);
	private destroyRef = inject(DestroyRef);

	readonly isVisible = input<boolean>();
	readonly modalEvent = output<any>();

	public indexOnEdit = -1;

	private readonly jobAlertResult = this.store.select<any>(JobAlertState.getState);

	public jobAlerts: any;

	public ngOnInit(): void {
		this.store.dispatch(new JobAlertActions.GetJobAlerts());

		this.jobAlertResult.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
			this.jobAlerts = data.map((e: any) => {
				const queryParams: any = {};
				if (e.keyword) {
					queryParams.search = e.keyword;
				}
				if (e.location) {
					queryParams.location = e.location;
				}
				if (e.category) {
					queryParams.category = e.category;
				}
				return {
					...e,
					queryParams
				};
			});
		});
	}

	public modalOk(): void {
		this.modalEvent.emit(null);
	}

	public modalCancel(): void {
		this.modalEvent.emit(null);
	}

	public edit(idx: number): void {
		this.indexOnEdit = idx;
	}

	public delete(id: number): void {
		this.nzModalService.confirm({
			nzTitle: `Delete this Job Alert?`,
			nzOkText: `Delete`,
			nzOkType: 'primary',
			nzOkDanger: true,
			nzOnOk: () => {
				this.store.dispatch(new JobAlertActions.DeleteJobAlert(id));
			},
			nzCancelText: `Cancel`
		});
	}

	public cancel(): void {
		this.indexOnEdit = -1;
	}
}
